import reducer from './filtersBlogs/reducer';
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
    filters:reducer
})

export default rootReducer;